import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { confirmable, createConfirmation, ReactConfirmProps } from 'react-confirm';
import { WithChildrenProps } from '.';
import { ThemeBlue, ThemeBlueDark } from "../themes/ThemeBlue";
import ErrorButton from './FormControl/ErrorButton';
import SuccessButton from './FormControl/SuccessButton';

interface ConfirmationOptions {
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | false;
    fullWidth?: boolean;
    okLabel?: React.ReactNode;
    cancelLabel?: React.ReactNode;
    confirmation?: React.ReactNode;
    title?: React.ReactNode;
    onProceed?: () => Promise<any> | any;
    onCancel?: () => any;
    component?: React.ReactElement
    disableBackdropClick?: boolean
    disableEscapeKeyDown?: boolean
    forceDismissOnClose?: boolean
}

interface ConfirmationDialogProps extends WithChildrenProps {
    options: ConfirmationOptions,
    ProceedButton?: React.ComponentType<ButtonProps>
}

export class ConfirmationDialog extends React.Component<ReactConfirmProps & ConfirmationDialogProps> {

    render() {
        const { show, proceed, dismiss, cancel, confirmation, options, children, ProceedButton } = this.props;
        const { maxWidth, fullWidth, okLabel, cancelLabel, title, onProceed, onCancel, component, disableBackdropClick, disableEscapeKeyDown, forceDismissOnClose } = options || {};
        const OkButton = ProceedButton || SuccessButton;
        var theme = localStorage.getItem("theme");
        return (
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme === 'dark' ? ThemeBlueDark : ThemeBlue}>
                    <Dialog
                        open={show}
                        aria-labelledby="responsive-dialog-title"
                        onClose={(ev, r) => {
                            if (r === 'backdropClick' && disableBackdropClick === true) return;
                            dismiss();
                        }}
                        maxWidth={maxWidth || false}
                        fullWidth={fullWidth || false}
                        disableEscapeKeyDown={disableEscapeKeyDown || false}
                        PaperProps={{
                            style: {
                                overflowY: 'unset'
                            }
                        }}
                    >
                        {title && <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>}
                        <DialogContent style={{ overflowY: 'unset' }}>
                            {confirmation ?
                                <DialogContentText>
                                    {confirmation}
                                </DialogContentText> :
                                (component || children)}
                        </DialogContent>
                        <DialogActions>
                            <ErrorButton
                                size='small'
                                variant='contained'
                                onClick={() => {
                                    if (typeof onCancel === 'function') {
                                        onCancel();
                                    }
                                    if (typeof onCancel !== 'function' || forceDismissOnClose === true) {
                                        dismiss();
                                    }
                                }} >
                                {cancelLabel || 'Cancelar'}
                            </ErrorButton>
                            <OkButton
                                size='small'
                                variant='contained'
                                onClick={async () => {
                                    if (typeof onProceed === 'function') {
                                        if ((await Promise.resolve(onProceed())) === false) {
                                            return;
                                        }
                                    }
                                    if (typeof proceed === 'function') {
                                        proceed('ok');
                                    }
                                }}
                                autoFocus>
                                {okLabel || 'OK'}
                            </OkButton>
                        </DialogActions>
                    </Dialog>
                </ThemeProvider>
            </StyledEngineProvider>
        );
    }
}

const ConfirmableDialog = confirmable<ConfirmationDialogProps>(ConfirmationDialog);

const confirm = createConfirmation(ConfirmableDialog, 400, document.querySelector('.App'));

export default function confirmation(confirmation?: React.ReactNode, options: Omit<ConfirmationOptions, 'confirmation'> = {}) {
    // You can pass whatever you want to the component. These arguments will be your Component's props
    return confirm({ confirmation, options });
}